/**
 * Databricks Client Service
 * Frontend service to fetch analytics data from Databricks via backend
 */

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:5001';

/**
 * Check Databricks connection status
 */
export async function getDatabricksStatus() {
  const response = await fetch(`${BACKEND_URL}/api/databricks/status`);
  return response.json();
}

/**
 * Get current market prices (WTI, Henry Hub, basis differentials)
 */
export async function getMarketPrices() {
  const response = await fetch(`${BACKEND_URL}/api/databricks/market-prices`);
  return response.json();
}

/**
 * Get operator performance metrics
 * @param {Object} filters - Optional filters { county, operator }
 */
export async function getOperatorMetrics(filters = {}) {
  const params = new URLSearchParams();
  if (filters.county) params.append('county', filters.county);
  if (filters.operator) params.append('operator', filters.operator);
  const queryString = params.toString();
  const url = `${BACKEND_URL}/api/databricks/operator-metrics${queryString ? `?${queryString}` : ''}`;
  const response = await fetch(url);
  return response.json();
}

/**
 * Get production summary by county
 * @param {Object} filters - Optional filters { county, operator }
 */
export async function getProductionSummary(filters = {}) {
  const params = new URLSearchParams();
  if (filters.county) params.append('county', filters.county);
  if (filters.operator) params.append('operator', filters.operator);
  const queryString = params.toString();
  const url = `${BACKEND_URL}/api/databricks/production/summary${queryString ? `?${queryString}` : ''}`;
  const response = await fetch(url);
  return response.json();
}

/**
 * Get production history for a specific well
 */
export async function getProductionHistory(wellApi) {
  const response = await fetch(`${BACKEND_URL}/api/databricks/production/${encodeURIComponent(wellApi)}`);
  return response.json();
}

/**
 * Get production forecast for a specific well
 */
export async function getProductionForecast(wellApi) {
  const response = await fetch(`${BACKEND_URL}/api/databricks/forecasts/${encodeURIComponent(wellApi)}`);
  return response.json();
}
